import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpParams, HttpStatusCode } from '@angular/common/http';
import { NotificationService } from './notification.service';
import { configJSON } from '../appConfig';
import { AuthService } from './auth.service';
import { ResponseMessageType } from '../common/enum';
import appConstant from '../../assets/app-text.json';
import  files from '../../assets/files.json';
import { ConnectionListService } from './shared-services/connection-list.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentEmailDownloadService {
  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
    private authService: AuthService,
    private connectionListService: ConnectionListService
  ) {}

  getEmailOrDownloadDocument(documentInfo: any) {
    const docSizeInMb = documentInfo.data.description.size / 1024;
    if (
      this.authService.getMaxFileSize() !== 0 &&
      docSizeInMb > this.authService.getMaxFileSize()
    ) {
      this.notificationService.error(
        appConstant.MAX_FILE_SIZE_DOWNLOAD +
          this.authService.getMaxFileSize() +
          ' MB'
      );
      return;
    }
    else if(documentInfo.event.toUpperCase() == "EMAIL" && docSizeInMb >= 30 ){
      this.notificationService.error(appConstant.MAX_FILE_SIZE_EMAIL);
    }
    var docObject = {
      docId: documentInfo.data.description.documentId,
      size: documentInfo.data.description.size,
      name: documentInfo.data.name,
      itemType: documentInfo.data.itemType,
      itemSubType: documentInfo.data.description.extension,
      downloadType: documentInfo.event,
      libraryGuid: documentInfo.data.description.libraryGuid
    }
    if(documentInfo.event.toUpperCase() == "DIRECT"){
      this.downloadDocument(docObject);
    }
    else if(documentInfo.event.toUpperCase() == "EMAIL"){
      this.sendEmailDocument(docObject);
    }
  }

  downloadDocument(documentInfo: any) {
    var fileName = documentInfo.name;
    var fileExtension = documentInfo.itemSubType;

    const params = new HttpParams()
      .set('docId', documentInfo.docId)
      .set('itemType', documentInfo.itemType)
      .set('itemSubType', documentInfo.itemSubType)
      .set('downloadType', documentInfo.downloadType)
      .set('fileType', this.getFileType(documentInfo.itemSubType.toLowerCase()))
      .set('libraryGuid', documentInfo.libraryGuid);

    this.http.get<any>(configJSON.getDownloadDocument, { params, withCredentials: true })
      .subscribe(
        (response) => {
          if ((response && response.message === ResponseMessageType.SUCCESS) && response.data && response.data.documentURL) {
            const a = document.createElement('a');
            a.href = response.data.documentURL;
            a.click();
          }
          else{
            const userMessage = response.errors[0].devMessage;;
            this.notificationService.error(userMessage);
          }
        },
        (error) => {
          this.notificationService.error(appConstant.ERROR_DOWNLOAD_MSG);
        });
  }

  sendEmailDocument(documentInfo: any) {
    const request = {
      docId: documentInfo.docId,
      itemType: documentInfo.itemType,
      itemSubType: documentInfo.itemSubType,
      downloadType: documentInfo.downloadType,
      fileType: this.getFileType(documentInfo.itemSubType.toLowerCase()),
      libraryGuid: documentInfo.libraryGuid
    };
    this.http
      .post<any>(configJSON.getEmailDocument, request, { withCredentials: true })
      .subscribe(
        (response) => {
          if ((response && response.message === ResponseMessageType.SUCCESS) && response.data) {
            this.notificationService.success(response.data.message);
          }
          else{
            const userMessage = response.errors[0].devMessage;;
            this.notificationService.error(userMessage);
          }
        },
        (error) => {
          this.notificationService.error(appConstant.ERROR_DOWNLOAD_MSG);
        });
  }

  downloadBlobDocument(event: any, fileName, fileExtension) {
    const blob = event.body;
    this.validateBlob(blob, fileName, fileExtension)
  }

  async validateBlob(blob: any, fileName, fileExtension) {
    if (blob.type === 'application/json') {
      const text = await blob.text();
      const json = JSON.parse(text);
      if (json.apiResponseStatus == "Failed") {
        this.notificationService.error(appConstant.ERROR_DOWNLOAD_MSG);
        return false;
      }
      else{
        this.proceedDownload(blob, fileName, fileExtension)
      }
    }
    else{
      this.proceedDownload(blob, fileName, fileExtension)
    }
  }

  proceedDownload(blob: any, fileName, fileExtension){
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName + '.' + fileExtension;
    a.click();
  }

  getFileType(extension: string){
    return files[extension] || 'application/octet-stream'; // Default to octet-stream if unknown
  }
}
